<template>
    <div id="app">
        <v-menu/>
        <router-view/>
    </div>
</template>

<script>
import Vue from 'vue'
import Menu from '@/components/Menu';

Vue.component('v-menu', Menu)

window.LOG_LEVEL = 'VERBOSE';

export default {
    name: 'app'
}
</script>

<style>
body {
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;

}
</style>



// WEBPACK FOOTER //
// src/App.vue